export enum EVENT_COURSE_STATUS {
  CREATED = 'CREATED',
  REVIEW = 'REVIEW',
  ACCEPTED = 'ACCEPTED',
  COMPLETED = 'COMPLETED',
  WAITING_PAY = 'WAITING_PAY',
  ERROR_PAY = 'ERROR_PAY',
  CANCELLED = 'CANCELLED',
  PAID = 'PAID',
}

export const EVENT_COURSE_STATUS_VALUES = Object.values(EVENT_COURSE_STATUS);
